import React from "react";
import {
	ChargerInfoResponse
} from "services/utils/interfaces";
import "./InfoSection.less";
import { Tag, Collapse } from "antd";
import useWindowDimensions from "../../../../common/functions";
import i18n from "i18next";
import { Button, Modal } from "antd";
import {
	RightCircleOutlined,
	RedoOutlined,
	CloseOutlined
} from "@ant-design/icons";

type Props = {
	data: ChargerInfoResponse,
	shouldRefresh: boolean,
	chargerId: string,
	status: string,
	popUpModal: Function,
	showModal: Function
};

const { Panel } = Collapse;

const InfoSection: React.FC<Props> = ({
	data,
	status,
	popUpModal,
	showModal
}): React.ReactElement => {

	const getStatus = () => {
		let color = "#CECECE";
		if (status === "Fault") {
			color = "#FF7866";
		} else if (status === "Available") {
			color = "#9DCC78";
		} else if (status === "Unavailable") {
			color = "#FED077";
		} else if (status.startsWith("In use")) {
			color = "#E088FF";
		}
		return <Tag className="tag" color={color} key={status}>{status.toUpperCase()}
		</Tag>;
	};

	const { width } = useWindowDimensions();
	const dataUpdated = {};
	Object.keys(data).forEach(key => {
		if (key === "chargerName") {
			dataUpdated[i18n.t("charger.chargerName")] = data[key].toUpperCase();
		} else if (key === "maxPower") {
			dataUpdated[i18n.t("charger.maxPower")] = data[key] + " " + data["maxPowerUnit"];
		} else if (key === "serialNum") {
			dataUpdated[i18n.t("charger.serialNum")] = data[key];
		} else if (key === "model") {
			dataUpdated[i18n.t("charger.model")] = data[key];
		} else if (key === "Type") {
			dataUpdated[i18n.t("charger.Type")] = data[key];
		} else if (key === "lastHeartBeat") {
			dataUpdated[i18n.t("charger.lastHeartBeat")] = data[key];
		}
	});



	return (
		<>
			{
				width > 768 && data ? (
					<>
						<section className="charger-info-header">
							<div className="charger-info-header-left">
								<div className="charger-Id">
									{data.chargerId}
								</div>
								<div className="charger-status">
									{getStatus()}
								</div>
							</div>
							<div>
								<Button type="primary" size='large' danger onClick={() => showModal()}>Assign to a user</Button>
								<Button className="charger-button" onClick={() => popUpModal("start")}>
									<RightCircleOutlined style={{ color: "green" }} />{i18n.t("charger.startCharger")}
								</Button>
								<Button className="charger-button" onClick={() => popUpModal("reboot")}>
									<RedoOutlined style={{ color: "orange" }} />{i18n.t("charger.rebootCharger")}
								</Button>
								<Button className="charger-button" onClick={() => popUpModal("stop")}>
									<CloseOutlined style={{ color: "red" }} />{i18n.t("charger.stopCharger")}
								</Button>
							</div>
						</section>

						<section className="get-charger-info-content">
							{Object.keys(dataUpdated).map(key => {
								return (<section key={key} className="info-card">
									<div className="key">
										{key}
									</div>
									<div className="property">
										{dataUpdated[key]}
									</div>
								</section>);
							})}
						</section>
					</>
				) : (data ? (
					<>
						<section className="charger-info-header">
							<div className="charger-Id">
								{data.chargerId}
							</div>
							<div className="charger-status">
								{getStatus()}
							</div>
						</section>

						<Collapse defaultActiveKey={["1"]} >
							{Object.keys(dataUpdated).map(key => {
								return (
									<Panel header={key} key={key}>
										<p>{dataUpdated[key]}</p>
									</Panel>
								);
							})}
						</Collapse>
					</>
				) : null)
			}
		</>
	);
};

export default InfoSection;
